module.exports = __webpack_public_path__ + "static/media/ti.c1677d38.png";